'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isMap(value) {
    return value instanceof Map;
}

exports.isMap = isMap;
